import React from 'react';
import { useState,  useRef,useEffect } from 'react';
import './classes/CourseOverview.css';
import './classes/marquee.css';
import CurrencyConverter from "./shortcodes/CurrencyConverter";
import SidebarQuickForm from './SidebarQuickForm';
import Mentor from './Mentor';
import { createRoot } from "react-dom/client";

import { configData } from "../config";

const Body = ({ page }) => {
  const app_url = configData.APP_URL;
 const bodyRef = useRef(null);
useEffect(() => {
    const ul = document.getElementById("marquee-horizontal");

    if (ul && !ul.dataset.initialized) {
        ul.innerHTML += ul.innerHTML;
        ul.dataset.initialized = "true";
    }
}, [page?.body]);
useEffect(() => {
    if (!bodyRef.current) return;

    bodyRef.current
        .querySelectorAll('[data-type="currency-converter"]')
        .forEach((element) => {
            createRoot(element).render(
                <CurrencyConverter
                    price={parseFloat(element.dataset.price)}
                />
            );
        });

         bodyRef.current
        .querySelectorAll('[data-type="mobile-quick-form"]')
        .forEach((element) => {
            createRoot(element).render(
                <div className="mobile-only">
                    <SidebarQuickForm page={page} />
                </div>
            );
        });
        bodyRef.current
        .querySelectorAll('[data-type="mobile-mentor-block"]')
        .forEach((element) => {
            createRoot(element).render(
                <div className="mobile-only">
                    <Mentor page={page} />
                </div>
            );
        });

}, [page?.body]);
// Home page video: on the Drupal site a script swaps the cover image for the
// video when it is clicked. Scripts in the body are not run here, so do the same.
useEffect(() => {
    if (!bodyRef.current) return;

    const overlays = bodyRef.current.querySelectorAll('.video_overlay');
    const playVideo = (event) => {
        const overlay = event.currentTarget;
        const cover = overlay.querySelector('.cover_image');
        if (!cover) return;

        const video = document.createElement('video');
        // The video sits next to its cover image in the Drupal files folder
        video.src = new URL('home_page_video1.mp4', cover.src).href;
        video.controls = true;
        video.autoplay = true;
        overlay.parentNode.replaceChild(video, overlay);
    };

    overlays.forEach((overlay) => overlay.addEventListener('click', playVideo));
    return () => overlays.forEach((overlay) => overlay.removeEventListener('click', playVideo));
}, [page?.body]);
  return (
    <div className="courses-overview-container">
      <div  ref={bodyRef}
                dangerouslySetInnerHTML={{
                    __html: page?.body || ""
                }}
            />
    </div>
  );
};
export default Body;